import { Tool } from '../../types';

export const learningTools: Tool[] = [
  {
    id: 'teachable',
    name: 'Teachable',
    category: 'Learning Management',
    description: 'Platform for creating and selling online courses',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['content-creator', 'freelancer'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['increase-sales', 'build-brand'],
    industries: ['education', 'creative', 'consulting'],
    website: 'https://teachable.com',
    imageUrl: 'https://logo.clearbit.com/teachable.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'thinkific',
    name: 'Thinkific',
    category: 'Learning Management',
    description: 'All-in-one platform for creating and selling courses',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['content-creator', 'small-business'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['increase-sales', 'build-brand'],
    industries: ['education', 'consulting', 'creative'],
    website: 'https://www.thinkific.com',
    imageUrl: 'https://logo.clearbit.com/thinkific.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'kajabi',
    name: 'Kajabi',
    category: 'Learning Management',
    description: 'All-in-one platform for knowledge businesses',
    pricing: ['high'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['content-creator', 'small-business'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['increase-sales', 'build-brand', 'automate-tasks'],
    industries: ['education', 'consulting', 'marketing'],
    website: 'https://kajabi.com',
    imageUrl: 'https://logo.clearbit.com/kajabi.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];